import gql from 'graphql-tag'

export const RETRIEVE_USER_BY_USERNAME = gql`
  query retrieveUserByUsername($username: String!) {
    retrieveUserByUsername(input: { username: $username }) {
      enabled
      lastModifiedDate
      registeredDate
      sub
      username
    }
  }
`

export const RETRIEVE_USER_BY_SUB = gql`
  query retrieveUserBySub($sub: String!) {
    retrieveUserBySub(input: { sub: $sub }) {
      enabled
      lastModifiedDate
      registeredDate
      sub
      username
    }
  }
`

export const GET_ENTITLEMENTS_FOR_USER = gql`
  query getEntitlementsForUser($externalId: String!) {
    getEntitlementsForUser(input: { externalId: $externalId }) {
      entitlements {
        entitlements {
          description
          name
          value
        }
      }
    }
  }
`

export const GET_EMAIL_ADDRESS_METADATA_BY_EMAIL_ADDRESS = gql`
  query getEmailAddressMetadataByEmailAddress($emailAddress: String!) {
    getEmailAddressMetadataByEmailAddress(emailAddress: $emailAddress) {
      emailAddress
      id
      owner
    }
  }
`

export const LIST_EMAIL_ADDRESSES_BY_SUB = gql`
  query listEmailAddressesBySub($sub: String!) {
    listEmailAddressesBySub(sub: $sub) {
      id
      emailAddress
    }
  }
`

export const LIST_VIRTUAL_CARDS_BY_SUB = gql`
  query listVirtualCardsBySub($sub: String!) {
    listVirtualCardsBySub(input: { sub: $sub }) {
      id
      state
      last4
      owners {
        id
      }
      keyId
      keyRingId
      createdAtEpochMs
      updatedAtEpochMs
      cancelledAtEpochMs
    }
  }
`

export const LIST_FUNDING_SOURCES_BY_SUB = gql`
  query listFundingSourcesBySub($sub: String!) {
    listFundingSourcesBySub(input: { sub: $sub }) {
      ... on CreditCardFundingSource {
        id
        last4
        network
        state
      }
    }
  }
`
